export enum ContactType {
  Primary = 'primary',
  Secondary = 'secondary',
}
